import { Global } from './global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { cpuUsage } from 'process';

@Injectable({
  providedIn: 'root'
})
export class HomeService{

    constructor(private http:HttpClient, private global:Global) { }
    urlService = this.global._Url + '/Services/'
    httpOptions = {
      headers: new HttpHeaders({
        "accept": "application/json;odata=Nometadata",
        "content-type": "application/json;odata=verbose"
      })
    };
    getDescription(code,url){
        return this.http.get(url+"/_api/web/lists/GetByTitle('BlocsDescription')/items?"
        +"$select=*&$filter=Code eq '" +code +"'",this.httpOptions);      
    }
    getNotifications(url){
      return this.http.get(url+"/_api/web/lists/GetByTitle('Notifications')/items?"
      +"$select=*,File/ServerRelativeUrl,FileLeafRef&$expand=File&$orderby=Modified desc",this.httpOptions);
    }
      getPortnet(){
      return this.http.get(this.global._basedUrl +"/_api/web/lists/GetByTitle('PortMaroc')/items?"
        +"$select=*,AttachmentFiles&$expand=AttachmentFiles",this.httpOptions);
    }
    getVideoByCode(code){
      return this.http.get(this.global._basedUrl +"/_api/web/lists/GetByTitle('LiensVideo')/items?"
      +"$select=*&$filter=Code eq '" + code + "'",this.httpOptions);
    }
    getMvmNaviresDeparts(){
      return this.http.get(this.global._basedUrl +"/_vti_bin/WS/Service.svc/mvmnv/departs",this.httpOptions);
    }
    getMvmNaviresArrivees(){
      return this.http.get(this.global._basedUrl +"/_vti_bin/WS/Service.svc/mvmnv/arrivees",this.httpOptions);
    }
  
  getAllServiceDataId( listName , lg) {
    const url =this.urlService  + lg +"/_api/web/lists/GetByTitle('"+listName+"')/items?"
    +"$select=Id,CodePort"

  return this.http.get(url ,this.httpOptions);
}
getPortSections(){
  return this.http.get(this.urlService +"_api/web/lists/GetByTitle('MenuPort')/items?"
    +"$select=*&$filter=PageDynamique eq 'Non'",this.httpOptions);
}
getChantiersInfrastructures(url){
  return this.http.get(url+"/_api/web/lists/GetByTitle('ChantiersInfrastructures')/items",this.httpOptions); 
}
   
}